import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import htmlParser from "html-react-parser";
// import { Helmet } from "react-helmet";

import TemplateXSNowContents from "Components/Templates/XSNowContents";
import TemplateNowContents from "Components/Templates/NowContents";

import * as styles from "styles";
import * as Types from "Types";
import * as enums from "enumerations";
import * as actions from "actions";

export default function Nows() {
   const params = useParams();
   const width = useSelector((state: Types.State) => state.dimensions.width);
   const nows = useSelector((state: any) => state.nows.get);
   const [getParameters]: any = useSearchParams();

   const dispatch = useDispatch();

   // let metaData: any = [];

   useEffect(() => {
      dispatch({ type: actions.nowContents.get.call, data: { now_id: params.now_id || getParameters.get("idx") } });
      dispatch({ type: actions.nows.get.call, data: { now_id: params.now_id || getParameters.get("idx") } });

      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [params.now_id, getParameters.idx]);

   // let seoData: any = [];
   // try {
   //    console.log("시도하다", nows.data.seo_json);
   //    seoData = JSON.parse(nows.data.seo_json);
   // } catch (err) {
   //    console.log(err, nows.data.seo_json);
   // }

   // metaData = seoData.map(function (meta: any) {
   //    if (typeof meta === "string") {
   //       return htmlParser(meta);
   //    } else {
   //       return meta.key === "description" ? <meta name={meta.key} content={meta.content} /> : <meta property={meta.key} content={meta.content} />;
   //    }
   // });

   return (
      <>
         {/* <Helmet>
            {metaData.map((row: any) => row)}
            {`<?php include_once("../../inc_meta.php"); ?>`}
         </Helmet> */}
         {styles.getGridSize(width) === enums.grid.sizes.xs || styles.getGridSize(width) === enums.grid.sizes.s || styles.getGridSize(width) === enums.grid.sizes.m ? (
            <TemplateXSNowContents nows={nows}></TemplateXSNowContents>
         ) : (
            <TemplateNowContents nows={nows}></TemplateNowContents>
         )}
      </>
   );
}
